const isListEmpty = (list?: unknown[] | null) => {
  const length = list?.length ?? 0;
  return length <= 0;
};

export default isListEmpty;
